import { Formik } from "formik";
import * as Yup from "yup";
import Input from "../../components/input";
import Button from "../../components/button";
import ImagePicker from "../../components/ui/imagePicker";
import { useEffect, useMemo, useState } from "react";
import Resizer from "react-image-file-resizer";
import {
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import { useLocation, useNavigate } from "react-router-dom";
import { handleToastMessage } from "src/js/handleToastMessage";
import { db, storage } from "src/firebase/firebase";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";
import { getDownloadURL, uploadBytesResumable, ref } from "firebase/storage";
import {
  getAdmin,
  getATMCardDetail,
  getCards,
  getTotalOffering,
  getUserCards,
} from "src/firebase/admin.js";
import Loader from "../../components/loader";
import Checkbox from "../../components/checkbox/checkbox";
import axios from "axios";
import resizeFile from "src/js/resizeImage";
import { resolve } from "path";
import isArray from "lodash/isArray";
import Select from "../../components/select/select";

// const storage = getStorage();
// const storageRef = ref(storage, "files");

const validationSchema = Yup.object().shape({
  cardNo: Yup.number()
    .required("Card number is required.")
    .typeError("Accept only number"),
  mmyy: Yup.string().required("MM/YY is required."),
  cvv: Yup.number()
    .required("CVV is required.")
    .typeError("Accept only number"),
  amount: Yup.number()
    .required("Amount is required.")
    .typeError("Accept only number"),
  offering: Yup.string().required("Card offering is required."),
  images: Yup.array().test({
    message: "Images length is in between 0 and 5",
    test: (val) => true,
  }),

  directUse: Yup.boolean(),
});
const initialValues = {
  cardNo: "",
  mmyy: "",
  cvv: "",
  offering: "",
  amount: "",
  images: [],

  directUse: false,
};
var compressImages = [];
const NewCard = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [frontImageProgress, setFrontImageProgress] = useState(0);
  const [backImageProgress, setBackImageProgress] = useState(0);
  const [receiptImageProgress, setReceiptImageProgress] = useState(0);
  const [cardLoading, setCardLoading] = useState(false);
  const [accountLimit, setAccountLimit] = useState("");
  const [cardDetail, setCardDetail] = useState({});
  const [cardOffering, setCardOffering] = useState(false);
  const [amount, setAmount] = useState<number>(0);
  const [frontImageLoading, setFrontImageLoading] = useState<boolean>(false);
  const [backImageLoading, setBackImageLoading] = useState<boolean>(false);
  const [recieptImageLoading, setRecieptImageLoading] =
    useState<boolean>(false);
  const { t } = useTranslation(["home"]);
  const location = useLocation();
  const navigate = useNavigate();
  const [initValue, setInitValue] = useState({});
  const [offering, setOffering] = useState([]);
  const id = new URLSearchParams(location.search).get("id");
  const isEdit = useMemo(() => {
    return id ? true : false;
  }, [id]);

  useEffect(() => {
    getCardList();
    getAccountLimit();
    getCardOffering();
  }, []);
  useEffect(() => {
    if (isEdit) {
      getCardDetail();
    } else {
      setInitValue(initialValues);
    }
  }, [isEdit]);

  const getCardOffering = async (id = "") => {
    let priceGroup;
    if (!isEdit) {
      const _data = await localStorage.getItem("account");
      const data = JSON.parse(_data);
      priceGroup = data?.priceGroup;
    } else {
      priceGroup = id;
    }
    setCardOffering(true);
    let result: any = await getTotalOffering(priceGroup);
    setCardOffering(false);

    setOffering(result);
  };

  const getCardDetail = async () => {
    setCardLoading(true);
    const _detail = await getATMCardDetail(id);
    setCardLoading(false);
    const _card = _detail[0];
    setCardDetail(_card);
    let _images = [];
    if (_card?.images?.length > 0) {
      _images = _card.images;
    } else {
      _card?.frontImage && _images.push(_card.frontImage);
      _card?.backImage && _images.push(_card.backImage);
      _card?.receiptImage && _images.push(_card.receiptImage);
    }
    getCardOffering(_card.offering.priceGroup.id);
    setInitValue({
      cardNo: _card.cardNo,
      mmyy: _card.mmyy,
      cvv: _card.cvv,
      amount: _card.amount,
      offering: _card.offering.id,
      // frontImage: _card.frontImage,
      // backImage: _card.backImage,
      // receiptImage: _card.receiptImage,
      images: _images,
    });
  };

  const getAccountLimit = async () => {
    const _data = await localStorage.getItem("account");
    const data = JSON.parse(_data);
    setAccountLimit(data.accountLimit ?? "");
  };

  const getCardList = async () => {
    const accoount = JSON.parse(await localStorage.getItem("account"));
    let result: any = await getUserCards(accoount.id);
    const cards = result.filter((item: any) => {
      let _time = new Date(item.date.seconds * 1000).getTime();
      return _time > Date.now() - 24 * 60 * 60 * 1000 && item.status === "paid";
    });
    const sum = cards.reduce((accumulator, object) => {
      return accumulator + parseInt(object.amount);
    }, 0);
    setAmount(sum);
  };

  const handleAddCard = async (cardValue) => {
    let values;
    if (isEdit) {
      values = {
        ...cardDetail,
        ...cardValue,
      };
    } else {
      values = cardValue;
    }
    let _amount = parseInt(values.amount);
    _amount += amount;
    if (_amount > parseInt(accountLimit)) {
      handleToastMessage("error", "Sorry, account limit has reached today");
      return;
    }
    values.offering = offering.find((item) => item.id === values.offering);
    setIsLoading(true);
    if (!isEdit) {
      let account = await JSON.parse(localStorage.getItem("account"));
      values.account = account;
      values.accountId = account.id;
      values.date = new Date();
      values.status = "pending";
      values.id = uuidv4();
    }
    console.log("values", values);
    const q = await query(
      collection(db, "Cards"),
      where("cardNo", "==", values.cardNo)
    );
    const querySnapshot = await getDocs(q);
    const data = querySnapshot.docs.map((item) => item.data());

    if (data.length > 0 && !isEdit) {
      setIsLoading(false);
      handleToastMessage(
        "error",
        "Duplicate card,card already submitted by another client"
      );
      return;
    }

    await setDoc(doc(db, "Cards", values.id), values);
    handleToastMessage(
      "success",
      isEdit ? "Card updated successfully" : "Card added successfully."
    );
    setInitValue({ ...initialValues });
    pushNotification();
    navigate(-1);
  };

  const getCompressImages = async (files: any) => {
    try {
      let promises = files.map(async (file) => {
        let _image = await getImage(file);
        return _image;
      });
      const results = await Promise.all(promises);
      return results;
    } catch (err) {
      console.log(err);
    }
  };

  const getImage = async (file: any) => {
    const _image = await new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        1500,
        1500,
        "JPEG",
        90,
        0,
        (uri) => {
          let _url: any = uri;
          _url.name = `images-${new Date().getTime()}`;
          resolve(_url);

          // setTimeout(() => {
          //   setCompressImages([...compressImages, uri]);
          // }, 100);
        },
        "blob",
        400,
        400
      );
    });

    return _image;
  };

  const pushNotification = async () => {
    const result = await getAdmin();
    const _fcm = result.filter((item) => item.fcm).map((item) => item.fcm);

    axios({
      method: "post",
      url: "https://us-central1-vizioncrypto-379118.cloudfunctions.net/sendNotification",
      data: {
        token: _fcm ?? [],
        title: "Supplier added a new card",
      },
    });
  };

  return (
    <div className="p-5">
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-xl text-darkBlack font-semibold">
          {t("Cards")} {t("Management")}
        </h2>

        <div className="flex gap-x-2">
          <h4 className="cursor-pointer" onClick={() => navigate("/")}>
            {" "}
            {t("Cards")} {t("Management")} /
          </h4>
          <span className="text-grey">
            {" "}
            {isEdit ? t("Update Card") : t("Add New Card")}
          </span>
        </div>
      </div>
      <div className="pb-4 bg-white">
        <h2 className="text-xl text-darkBlack font-semibold py-2 px-5 border-b-2">
          {isEdit ? t("Update Card") : t("Add New Card")}
        </h2>
        <div className="p-5">
          {cardLoading && (
            <div className="flex justify-center">
              <Loader />
            </div>
          )}
          {Object.keys(initValue).length > 0 && (
            <Formik
              enableReinitialize
              initialValues={initValue}
              validationSchema={validationSchema}
              onSubmit={handleAddCard}
              validateOnBlur
            >
              {({
                values,
                errors,
                touched,
                handleSubmit,
                setFieldTouched,
                setFieldValue,
                handleBlur,
                handleChange,
                isSubmitting,
              }) => {
                const uploadImage = async (files: any) => {
                  let _comressFiles = await getCompressImages(files);

                  _comressFiles.forEach(async (file) => {
                    const storageRef = ref(storage, file.name);
                    const uploadTask = uploadBytesResumable(storageRef, file);
                    uploadTask.on(
                      "state_changed",
                      (snapshot) => {
                        const progress =
                          (snapshot.bytesTransferred / snapshot.totalBytes) *
                          100;

                        setFrontImageProgress(progress);
                        if (progress === 100) {
                          setFrontImageLoading(false);
                        } else {
                          setFrontImageLoading(true);
                        }

                        switch (snapshot.state) {
                          case "paused":
                            console.log("Upload paused");
                            break;
                          case "running":
                            console.log("Upload running", progress);
                            break;
                          default:
                            break;
                        }
                      },
                      (error) => {
                        console.log(error);
                      },
                      () => {
                        getDownloadURL(uploadTask.snapshot.ref).then(
                          async (downloadedURL) => {
                            let _images = values.images;

                            _images.push(downloadedURL);

                            await setFieldValue("images", _images);
                            setFieldTouched("images", true);
                          }
                        );
                      }
                      //
                    );
                    // uploadBytes(storageRef, file).then((snapshot) => {
                    //   console.log("Uploaded a blob or file!");
                    //   console.log(snapshot);
                    // });
                    // console.log("@@@@@@");
                    // const path = `/images/${file.name}`;
                    // const ref = storage.ref(path);
                    // await ref.put(file);
                    // const url = await ref.getDownloadURL();
                    // console.log("url:", url);

                    // var reader = new FileReader();
                    // reader.onloadend = function () {
                    //   setFieldTouched(fieldName, true);
                    //   setFieldValue(fieldName, reader.result);
                    // };
                    // reader.readAsDataURL(file);
                  });
                };
                return (
                  <form onSubmit={handleSubmit}>
                    <div className="flex gap-3 mb-2">
                      <Input
                        label="Card No"
                        containerClass="w-full"
                        placeholder="Card No"
                        name="cardNo"
                        className="flex-1"
                        error={errors.cardNo}
                        touched={touched.cardNo}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.cardNo}
                        variant="solid"
                      />
                      <Input
                        label="MM/YY"
                        className="flex-1"
                        containerClass="w-full"
                        placeholder="MM/YY"
                        name="mmyy"
                        error={errors.mmyy}
                        touched={touched.mmyy}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.mmyy}
                        variant="solid"
                      />
                    </div>

                    <div className="flex gap-3 mb-2">
                      <Input
                        label="Cvv"
                        containerClass="w-full"
                        placeholder="Cvv"
                        name="cvv"
                        className="flex-1"
                        error={errors.cvv}
                        touched={touched.cvv}
                        variant="solid"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.cvv}
                      />
                      <Input
                        label="Amount"
                        className="flex-1"
                        containerClass="w-full"
                        placeholder="Amount"
                        name="amount"
                        error={errors.amount}
                        touched={touched.amount}
                        value={values.amount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        variant="solid"
                      />
                    </div>

                    <div className="flex gap-3 mb-2 mt-2">
                      <div>
                        <ImagePicker
                          className="flex-1"
                          title="please upload card front image, back image and reciept image"
                          error={errors.images as string}
                          value={values.images}
                          touched={touched.images as boolean}
                          resetValue={() => {
                            setFieldValue("images", []);
                          }}
                          onChange={(files) => uploadImage(files)}
                        />
                        <div className="flex items-center justify-start w-fit gap-6 text-blue">
                          {frontImageLoading && <Loader />}{" "}
                          {frontImageProgress > 0 &&
                            frontImageLoading &&
                            frontImageProgress.toFixed() + "%"}
                        </div>
                      </div>
                      {/* <div>
                        <ImagePicker
                          className="flex-1"
                          title="Card Back Image"
                          error={errors.backImage as string}
                          value={values.backImage}
                          touched={touched.backImage as boolean}
                          resetValue={() => {
                            setFieldValue("backImage", "");
                          }}
                          onChange={(file) => uploadImage(file, "backImage")}
                        />
                        <div className="flex items-center justify-start w-fit gap-6 text-blue">
                          {backImageLoading && <Loader />}{" "}
                          {backImageProgress > 0 &&
                            backImageLoading &&
                            backImageProgress.toFixed() + "%"}
                        </div>
                      </div> */}
                    </div>
                    {/* <div>
                      <ImagePicker
                        className="flex-1"
                        title="Receipt Image"
                        value={values.receiptImage}
                        error={errors.receiptImage as string}
                        touched={touched.receiptImage as boolean}
                        resetValue={() => {
                          setFieldValue("receiptImage", "");
                        }}
                        onChange={(file) => uploadImage(file, "receiptImage")}
                      />
                      <div className="flex items-center justify-start w-fit gap-6 text-blue">
                        {recieptImageLoading && <Loader />}{" "}
                        {receiptImageProgress > 0 &&
                          <recieptImageLoading> &&
                          receiptImageProgress.toFixed() + "%"}
                      </div>
                    </div> */}
                    <h6 className="font-bold mb-1">Select Card Offering</h6>
                    <Select
                      isLoading={cardOffering}
                      options={offering.map((item) => {
                        return {
                          value: item.id,
                          label: item.name,
                        };
                      })}
                      onChange={(value: any) => {
                        setFieldTouched("offering", true);
                        setFieldValue("offering", value.value);
                      }}
                    />
                    {errors.offering && touched.offering && (
                      <p className="text-xs text-red">
                        {errors.offering as any}
                      </p>
                    )}
                    <Checkbox
                      label="Direct Use"
                      name="directUse"
                      className="mt-3"
                      onChange={(e) => {
                        setFieldTouched("directUse", true);
                        setFieldValue("directUse", e.target.checked);
                      }}
                    />

                    <div className="flex justify-end">
                      <Button
                        size="medium"
                        className="ml-0 block bg-blue mt-4 mb-3"
                        loading={isLoading}
                        type="button"
                        onClick={handleSubmit as any}
                      >
                        {isEdit ? t("Update") : t("Add")}
                      </Button>
                    </div>
                  </form>
                );
              }}
            </Formik>
          )}
        </div>
      </div>
    </div>
  );
};
export default NewCard;
